require("./event-basic-data-form.scss")

import { Component, Input, Output, EventEmitter }  from '@angular/core';
import { FormBuilder, Validators, FormGroup }     from '@angular/forms';

import { Event, Venue, EventCategory } from "../../models";
import { VenueApi } from "../../services/webservice";
import { ValidationService } from '../../services';

@Component({
	selector: 'event-basic-data-form',
	templateUrl: "./event-basic-data-form.html",
	styles: [require('./event-basic-data-form.scss')],
	providers: [VenueApi]
})
export class EventBasicDataForm {

	@Output() eventChange: EventEmitter<{ event: Event, eventCategory: EventCategory }> =
		new EventEmitter<{ event: Event, eventCategory: EventCategory }>();

	private _event: Event;
	private _eventCategories: EventCategory[]
	private _eventCategory: EventCategory
	private eventForm: FormGroup;

	@Input()
	set event(event: Event) {
		if (event) {
			this._event = event;
			this.createForm(this._event);
		}
	}

	@Input()
	set eventCategories(eventCategories: EventCategory[]) {
		if (eventCategories) {
			this._eventCategories = eventCategories
		}
	}

	@Input()
	set eventCategory(eventCategory: EventCategory) {
		if (eventCategory) {
			// da der dropdown mit der referenz der objekte arbeitet, muss die ausgewaehlte rubrik aus der liste, welche
			// die dropdown befuellt, verwendet werden. ansonsten refernziert die ausgewaehlte rubrik nicht ein objekt in
			// der dropdown und die auswahl im dropdown funktioniert nicht
			this._eventCategory = this._eventCategories.filter(ec => ec.uuid === eventCategory.uuid)[0]
		}
	}

	public constructor(private formBuilder: FormBuilder, private venueApi: VenueApi) {
		this.createForm(new Event());
	}

	public submitEvent(eventFromForm: any) {
		let event: Event = this.convertEvent(eventFromForm);
		this.eventChange.emit({ event: event, eventCategory: eventFromForm.eventCategory });
	}

	public hasInvalidateDateFields() {
		if (this.eventForm.controls['dateControls'].hasError('endBeforeBegin')) {
			return true
		}
		return false
	}

	public convertVenue(venue: Venue): {id: number, displayText: string} {
		return {id: venue.storageId, displayText: venue.name}
	}

	public searchVenues = (query: string) => {
		return this.venueApi.autocomplete(query)
	}

	public getVenue = (id: string) => {
		return this.venueApi.getVenueById(id)
	}

	private convertEvent(eventFromForm: any): Event {
		let event: Event = new Event()
		event.title = eventFromForm.title
		event.begin = eventFromForm.dateControls.begin
		event.end = eventFromForm.dateControls.end
		event.subtitle = eventFromForm.subtitle
		event.doorsOpenOffset = parseInt(eventFromForm.doorsOpen)
		event.eventManager = eventFromForm.eventManager
		event.eventNotes = eventFromForm.eventNotes;
		event.description = eventFromForm.description
		event.venueId = eventFromForm.venue;
		event.startOfSale = eventFromForm.startOfSale;
		event.testEvent = eventFromForm.testEvent;
		event.seasonEvent = eventFromForm.seasonEvent;
		event.personalizeTkts = eventFromForm.personalizeTkts;
		if (this._event) {
			event.uuid = this._event.uuid;
			event._links = this._event._links;
		}
		return event
	}

	private createForm(event: Event) {
		this.eventForm = this.formBuilder.group({
			title: [event.title, Validators.required],
			subtitle: [event.subtitle],
			eventNotes: [event.eventNotes],
			description: [event.description],
			doorsOpen: [event.doorsOpenOffset ? event.doorsOpenOffset + "" : "", ValidationService.positiveInteger],
			startOfSale: [event.startOfSale],
			eventManager: [event.eventManager],
			venue: [event.venueId, Validators.required],
			dateControls: this.formBuilder.group({
				begin: [event.begin, Validators.required],
				end: [event.end]
			}, { validator: ValidationService.endBeforeBeginDate('begin', 'end') }),
			eventCategory: this._eventCategory ? [this._eventCategory] : [],
			testEvent: [event.testEvent],
			seasonEvent: [event.seasonEvent],
			personalizeTkts: [event.personalizeTkts]
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/event-basic-data-form/event-basic-data-form.component.ts